/**
 * TimeTile — HH:MM-klokka på kjøkkenskjermen (Plan 01-14, restylet i #160).
 *
 * Stell_Kjokken: 132 px, vekt 800, tett sperring. Størrelsen er
 * `text-display-xl` (theme.css), ingen inline fontSize — W11.
 *
 * Tick discipline (useMinuteClock):
 *  - On mount, align the first tick to the next minute boundary via
 *    `60_000 - (Date.now() % 60_000)` so the clock flips on :00, not on mount.
 *  - After the alignment tick, setInterval every 60_000ms.
 *  - No cumulative layout shift: `.tnum` (tabular numerals) + a three-span
 *    layout keeps HH and MM widths fixed regardless of the glyph.
 */
import { useMinuteClock } from '../../../components/hooks/useMinuteClock';
import { formatTime } from '../../../i18n/formatters';

export function TimeTile() {
  const now = useMinuteClock();
  const [hh, mm] = formatTime(now).split(':');
  return (
    <div
      data-testid="time-tile"
      className="text-display-xl tnum text-ink leading-none font-extrabold tracking-tighter"
    >
      <span>{hh}</span>
      <span>:</span>
      <span>{mm}</span>
    </div>
  );
}
